import { ITrackAddNewFlatByNumberParameters, trackAddNewMyHomeObject } from './tracking';
import { EMyHomeEstimationTargets } from '../types/estimationTarget';
import { IFormFields } from '../types/formFields';

interface IUseGetTrackAddMyHomeObjectProps {
  isSubmit?: boolean;
  estimationTarget: EMyHomeEstimationTargets;
  filters: IFormFields;
  isNewbuilding?: boolean;
}

export const useGetTrackAddMyHomeObject = ({
  estimationTarget,
  filters,
  isSubmit,
  isNewbuilding,
}: IUseGetTrackAddMyHomeObjectProps) => {
  const { roomsCount, area, userSetArea, userSetRoomsCount, address, flatNumber, landArea, isChatSubscribeActive } =
    filters;

  const parameters: ITrackAddNewFlatByNumberParameters = {
    result: {
      address,
      flatnumber: flatNumber,
      roomsnumber: roomsCount,
      area,
      landarea: landArea,
      chatEnabled: isChatSubscribeActive,
    },
  };

  if (estimationTarget === EMyHomeEstimationTargets.flat) {
    parameters['autofiiled'] = {
      roomsnumber: !userSetRoomsCount ? roomsCount : undefined,
      area: !userSetArea ? area : undefined,
    };
  }

  return () =>
    trackAddNewMyHomeObject({
      label: isSubmit ? 'EstateCalculatorSuccess' : 'EstateCalculator',
      estimationTarget,
      parameters,
      isNewbuilding,
    });
};
